import router from './router'
import store from '@/store'
import { getStore } from '@/utils/storage'

router.beforeEach(async (to, from, next) => {
  // console.log(111, to, from, next)
  if (getStore('token') || to.path.includes('/404')) {
    if (to.path.includes('login')) {
      next('/')
    } else {
      if (getStore('sentry_id')) {
        await store.dispatch('getMqtt', { park_id: getStore('park_id'), sentry_id: getStore('sentry_id') })
      }
      next()
    }
  } else if (!to.path.includes('login')) {
    next('/login')
  } else {
    next()
  }
})
